import { Form, Input, Table } from 'antd'
import React, { useEffect } from 'react'

const OrderDetail = ({ dataSource }) => {

  const Order = dataSource?.Order;
  const EmailCustomer = dataSource?.EmailCustomer;

  const [form] = Form.useForm();

  useEffect(() => {
    if (form && Order) {
      form.setFieldsValue(Order);
    }
  }, [form, Order]);


  return (
    <div>

      <Form
        name="basic"
        layout="vertical"
        // onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
      >
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-4 mb-0">

          <Form.Item
            label="Order Quotation"
            name="OrderQuotation"
          >
            <Input placeholder="Order Quotation" disabled />
          </Form.Item>

          <Form.Item
            label="Order Date"
            name="OrderDate"
          >
            <Input placeholder="Order Date" disabled />
          </Form.Item>

          <Form.Item
            label="Customer Name"
            name="CustomerName"
          >
            <Input placeholder="Customer Name" disabled />
          </Form.Item>

          <Form.Item
            label="Sales Name"
            name="SalesName"
          >
            <Input placeholder="Sales Name" disabled />
          </Form.Item>

          <Form.Item
            label="Contact Person"
            name="ContactPerson"
          >
            <Input placeholder="Contact Person" disabled />
          </Form.Item>

          <Form.Item
            label="Address"
            name="Address"
          >
            <Input placeholder="Address" disabled />
          </Form.Item>

          <Form.Item
            label="Email Contact"
            name="EmailContact"
          >
            <Input placeholder="Email Contact" disabled />
          </Form.Item>

          <Form.Item
            label="Phone"
            name="Phone"
          >
            <Input placeholder="Phone" disabled />
          </Form.Item>

          <Form.Item
            label="Mobile Phone"
            name="MobilePhone"
          >
            <Input placeholder="Mobile Phone" disabled />
          </Form.Item>

          <Form.Item
            label="Fax"
            name="Fax"
          >
            <Input placeholder="Fax" disabled />
          </Form.Item>

          <Form.Item
            label="Department"
            name="Department"
          >
            <Input placeholder="Department" disabled />
          </Form.Item>

          <Form.Item
            label="Max TAT"
            name="MaxTAT"
          >
            <Input placeholder="Max TAT" disabled />
          </Form.Item>

          <Form.Item
            label="Decription"
            name="Decription"
            className="lg:col-span-3"
          >
            <Input.TextArea placeholder="Decription" disabled rows={4} />
          </Form.Item>
        </div>

      </Form>

      <div>
        <h1 className="border-b-2 pb-1 text-xl mb-2">Customer Email</h1>
        <Table
          bordered
          columns={columns}
          dataSource={EmailCustomer}
          scroll={{
            x: 'max-content',
          }}
        />
      </div>

    </div>
  )
}

export default OrderDetail;


const columns = [
  {
    key: 'Email',
    title: 'Email',
    dataIndex: 'Email',
  },
  {
    key: 'ContactName',
    title: 'Contact Name',
    dataIndex: 'ContactName',
  },
  {
    key: 'Authority',
    title: 'Authority',
    dataIndex: 'Authority',
  },
];